export default __webpack_public_path__ + "static/media/2084.30def75c.png";